/* eslint-disable no-unreachable */
export const marginsActions = {
  SORTING: "SORTING",
  FILTERING: "FILTERING",
  INIT: "INIT",
};

/**
 * Init items
 * @param {array} margins
 * @param {object} meta
 * @param {number} meta.total_count
 * @param {number} meta.total
 * @param state
 * @return {object} new state
 */
const initItems = (margins, meta, state) => {
  // rebuild campaign request in according to UI necessity
  state.pager.setTotal(meta);

  return {
    ...state,
    margins,
  };
};

export const marginGridReducer = (state, action) => {
  switch (action.type) {
    case marginsActions.INIT:
      return initItems(action.data, action.pager, state);

    default:
      throw new Error("Method is not implemented");
  }
};
